import { lazy, type FC } from 'react';
import { Navigate, Route } from 'react-router';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageHeader } from 'src/components/layout/page-header';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { useBidCollectorRoot } from 'src/pages/snam-bid-collector/use-bid-collector';

const LocationsOverviewPage = lazy(() => import('./locations-overview'));
const BidsOverviewPage = lazy(() => import('./bids-overview'));

export const SnamBidCollector: FC = () => {
  const bidCollectorRoot = useBidCollectorRoot();

  if (!bidCollectorRoot.response) {
    return <PageSpinner />;
  }

  if (!bidCollectorRoot.response.data._links.toggleFeature)
    return <ThrowNotFound />;

  return (
    <div className="grid gap-xl">
      <PageHeader title="Bid Collector" />

      <Tabs>
        <Link to="/transport/snam-bid-collector/settings">Settings</Link>
        <Link to="/transport/snam-bid-collector/bids">Bids</Link>
      </Tabs>

      <RootRoutes>
        <Route
          path="/transport/snam-bid-collector"
          element={
            <Navigate replace to="/transport/snam-bid-collector/settings" />
          }
        />

        <Route
          path="/transport/snam-bid-collector/settings"
          element={
            <LocationsOverviewPage bidCollectorRoot={bidCollectorRoot} />
          }
        />

        <Route
          path="/transport/snam-bid-collector/bids"
          element={<BidsOverviewPage bidCollectorRoot={bidCollectorRoot} />}
        />

        <Route path="*" element={<ThrowNotFound />} />
      </RootRoutes>
    </div>
  );
};
